import axios from '@/lib/axios';
import { PaymentTaskDocument, PurchaseOrderContractTask, PurchaseOrderContractTaskDocument, PurchaseOrderMember } from '@/hooks/api/models';
import { useMutation, useQuery } from '@tanstack/react-query';
import queryClient from '@/lib/queryClient';

/**
 * 1060. 支払タスクファイル一覧
 * [POST] /workspaces/:identifier/teams/:team_id/purchase_orders/:purchase_order_id/payment_tasks/:task_id/payment_task_documents
 */
type Props = {
  identifier: string;
  team_id: number;
  purchase_order_id: number;
  task_id: number;
};

const paymentTaskDocuments = (props: Props): Promise<PaymentTaskDocument[]> => {
  return axios.get(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.purchase_order_id}/payment_tasks/${props.task_id}/payment_task_documents`
  );
};

export const usePaymentTaskDocuments = (props: Props) => {
  return useQuery({
    queryKey: queryKey(props),
    queryFn: () => paymentTaskDocuments(props),
  });
};

export const usePaymentTaskDocumentsInvalidate = (props: Props) => {
  const invalidate = () => {
    queryClient.invalidateQueries({ queryKey: queryKey(props) });
  };

  return { invalidate };
};

const queryKey = (props: Props) => {
  return [
    'workspaces',
    props.identifier,
    'teams',
    props.team_id,
    'purchase_orders',
    props.purchase_order_id,
    'purchase_order_contract_tasks',
    props.task_id,
    'payment_task_documents',
  ];
};
